import { Component, ViewEncapsulation, forwardRef, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputControlBase } from '../base/input-control-base/input-control.base';

@Component({
  selector: 'app-input-number-control',
  templateUrl: './input-number-control.component.html',
  styleUrls: ['./input-number-control.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputNumberControlComponent),
      multi: true
    }
  ]
})
export class InputNumberControlComponent extends InputControlBase<number> {
  
  constructor(){
    super();
  }
  protected onInit(): void {
    this.initCss();
  }  
  protected onDestroy(): void {
  }
  protected onChanges(changes: SimpleChanges): void {
  }
  protected onDoCheck(): void {
  }
  protected onAfterContentInit(): void {
  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {    
  }

  private initCss() {
    this.defaultCss += ` ${this.css}`;
  }

  public inputChanged($event: any) {
    this.onChangeFn(this.value);
    this.onChanged.emit($event);
  }
}